export default {
  link_action: 'Link',
  url_placeholder: 'https://',
  edit_link: 'Edit link',
  remove_link: 'Remove link',
  editor_error: 'Failed to load the editor. Please refresh the page.',
}
